import { createApp } from 'vue';
import { createWebHashHistory, createRouter } from 'vue-router';

import App from '../vue/App.vue';
import AppSimActivation from '../vue/AppSimActivation.vue';
import AppLogin from '../vue/AppLogin.vue';
import AppAccount from '../vue/AppAccount.vue';
import Account from '../vue/pages/Account.vue';
import MyBills from '../vue/pages/MyBills.vue';
import MyAccount from '../vue/pages/MyAccount.vue';
import AppPricelist from '../vue/AppPricelist.vue';
import RoamingSteps from '../vue/RoamingSteps.vue';
import AppRoaming from '../vue/AppRoaming.vue';
import Usages from '../vue/pages/Usages.vue';
import Settings from '../vue/pages/Settings.vue';

const apps = [];
const containers = [
  {
    selector: '.vue-js-steps',
    component: App,
  },
  {
    selector: '.js-sim-activation',
    component: AppSimActivation,
  },
  {
    selector: '.js-sim-login',
    component: AppLogin,
  },
  {
    selector: '.vue-js-account',
    component: AppAccount,
    routes: [
      { path: '/', component: Account },
      { path: '/profile', component: MyAccount },
      { path: '/bills', component: MyBills },
      { path: '/usages', component: Usages },
      { path: '/settings', component: Settings },
    ]
  },
  {
    selector: '.vue-js-pricelist',
    component: AppPricelist,
  },
  {
    selector: '.vue-js-roaming-steps',
    component: RoamingSteps,
  },
  {
    selector: '.vue-js-roaming',
    component: AppRoaming,
  }
];

const initVue = (target, component, routes = null) => {
  const appContainer = document.querySelector(target);
  const app = createApp(component);
  apps.push(app);
  if (!appContainer) return;

  app.config.globalProperties.theme_path = window.theme_path;

  if (routes) {
    const router = createRouter({
      history: createWebHashHistory(),
      routes,
    });
    app.use(router);
  } 
};

containers.forEach(container => {
  initVue(container.selector, container.component, container.routes);
});

apps.map((app, index) => {
  const container = document.querySelector(containers[index].selector);
  if(container) {
    app.mount(container)
  }
});
